import { IIAMEntity } from "api/entities/iam-entity";
import { Entity } from "../../api/entities/id-name";
import { DialogActions } from "./dialog";

const IAM_ENTITY_NAME = 'IAMEntity';

export const DELETE_CONFIRMATION_DIALOG_NAME = "deleteConfirmation";

export const getIAMEntityName = () => IAM_ENTITY_NAME;

class IAMEntityActions<TListItem extends Entity> {
    readonly entity;
    readonly deleteConfirmation;

    constructor() {
        this.deleteConfirmation = new DialogActions<TListItem>(IAM_ENTITY_NAME, DELETE_CONFIRMATION_DIALOG_NAME);
    }
}

export const iamEntityActions = new IAMEntityActions();
